export default "__VITE_ASSET__CPb$ieJx__"